import { onboardingConstants } from '../actions/constants/onboardingConstants';
import { authConstants } from '../actions/constants/authConstants';

const onboardingInitialState = {
  isLoading: false,
  lastInvite: null,
  signupDraft: null,
  signupData: null,
  kycData: null,
  error: null,
  isSuccess: false,
};

export const onboardingReducer = (state = onboardingInitialState, action: any) => {
  switch (action.type) {
    case onboardingConstants.inviteUserRequest:
    case onboardingConstants.signupRequest:
    case onboardingConstants.verifyKycRequest:
    case onboardingConstants.referralDecisionRequest:
    case onboardingConstants.fetchDraftRequest:
      return { ...state, isLoading: true, error: null };

    case onboardingConstants.saveDraft:
      return { ...state, signupDraft: action.payload };

    case onboardingConstants.inviteUserSuccess:
      return { ...state, isLoading: false, lastInvite: action.payload, isSuccess: true, error: null };

    case onboardingConstants.signupSuccess:
      return {
        ...state,
        isLoading: false,
        signupDraft: null,
        signupData: action.payload,
        error: null
      };

    case onboardingConstants.verifyKycSuccess:
      return {
        ...state,
        isLoading: false,
        kycData: action.payload,
        error: null,
      };

    case onboardingConstants.fetchDraftSuccess:
      return {
        ...state,
        isLoading: false,
        signupDraft: action.payload,
        error: null
      };

    case onboardingConstants.referralDecisionSuccess:
      return { ...state, isLoading: false };

    case onboardingConstants.inviteUserFailure:
    case onboardingConstants.signupFailure:
    case onboardingConstants.verifyKycFailure:
    case onboardingConstants.referralDecisionFailure:
    case onboardingConstants.fetchDraftFailure:
      return { ...state, isLoading: false, error: action.payload };

    case authConstants.userLogoutSuccess:
      return { ...state, signupDraft: null, signupData: null };

    default:
      return state;
  }
};

const referralInitialState = {
  referrals: {
    data: [],
    pagination: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
    loading: false,
    error: null,
  },
  userDetails: {
    data: null,
    loading: false,
    error: null,
  },
};

export const referralReducer = (state = referralInitialState, action: any) => {
  switch (action.type) {
    // Fetch Referrals
    case onboardingConstants.fetchReferralsRequest:
      return {
        ...state,
        referrals: { ...state.referrals, loading: true, error: null }
      };

    case onboardingConstants.fetchReferralsSuccess:
      return {
        ...state,
        referrals: {
          data: action.payload.data || [],
          pagination: action.payload.pagination || state.referrals.pagination,
          loading: false,
          error: null
        }
      };

    case onboardingConstants.fetchReferralsFailure:
      return {
        ...state,
        referrals: { ...state.referrals, loading: false, error: action.payload }
      };

    // Fetch User Details
    case onboardingConstants.fetchUserDetailsRequest:
      return {
        ...state,
        userDetails: { ...state.userDetails, loading: true, error: null }
      };

    case onboardingConstants.fetchUserDetailsSuccess:
      return {
        ...state,
        userDetails: { data: action.payload, loading: false, error: null }
      };

    case onboardingConstants.fetchUserDetailsFailure:
      return {
        ...state,
        userDetails: { ...state.userDetails, loading: false, error: action.payload }
      };

    default:
      return state;
  }
};

const decisionInitialState = {
  decision: {
    loading: false,
    error: null,
    success: false,
  },
};

export const decisionReducer = (state = decisionInitialState, action: any) => {
  switch (action.type) {
    // Process Decision
    case onboardingConstants.processDecisionRequest:
      return {
        ...state,
        decision: { loading: true, error: null, success: false }
      };

    case onboardingConstants.processDecisionSuccess:
      return {
        ...state,
        decision: { loading: false, error: null, success: true }
      };

    case onboardingConstants.processDecisionFailure:
      return {
        ...state,
        decision: { loading: false, error: action.payload, success: false }
      };

    case onboardingConstants.processDecisionReset:
      return {
        ...state,
        decision: { loading: false, error: null, success: false }
      };

    default:
      return state;
  }
};
